// TaskSubtask Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Checkbox from '../../../common/form/checkbox/checkbox.jsx'
import Input from '../../../common/form/input/input.jsx'

class TaskSubtask extends Component {
  constructor (props) {
    super(props)

    this._references = {
      input: React.createRef()
    }
  }

  static get propTypes () {
    return {
      subtask: PropTypes.object,
      onComplete: PropTypes.func,
      onUpdate: PropTypes.func,
      onUpdateEditable: PropTypes.func,
      onDelete: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      subtask: null,
      onComplete: null,
      onUpdate: null,
      onUpdateEditable: null,
      onDelete: null
    }
  }

  componentDidMount () {
    if (
      this._references.input.current &&
      this.props.subtask &&
      this.props.subtask.editable === 'title'
    ) {
      this._references.input.current.focus()
    }
  }

  render () {
    const { subtask, onComplete, onDelete } = this.props
    return (
      <div className='task-subtask'>
        {!subtask.disabled && (
          <div className='action actiondelete' onClick={onDelete}>
            <span className='iconcont'>
              <i className='icon icon-planner-delete' />
            </span>
          </div>
        )}
        <div className='check'>
          <Checkbox
            checked={subtask.completed}
            canHover={false}
            disabled={subtask.disabled}
            icon='dashboardsubtask'
            className='taskcompleted'
            onChange={onComplete}
          />
        </div>
        <div className='title'>
          {subtask.editable === 'title' ? (
            <Input
              type='text'
              name='title'
              maxLength={120}
              disabled={subtask.disabled}
              label='planner.planner.labelSubTask'
              required
              className='subtaskinput'
              validations={['required']}
              value={subtask.title}
              ref={this._references.input}
              onChange={
                !subtask.disabled
                  ? this._onChangeInput.bind(this, subtask, 'title')
                  : null
              }
              onBlur={this._onBlur.bind(this, subtask, 'title')}
              onKeyDown={this._onKeyPressInput.bind(this, subtask, 'title')}
            />
          ) : (
            <span
              onClick={
                !subtask.disabled
                  ? this._onEdit.bind(this, subtask, 'title')
                  : null
              }
            >
              {subtask.title}
            </span>
          )}
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onEdit (subtask, name) {
    subtask.editable = name
    this.setState({ dataDate: new Date() })
  }

  _onChangeInput (subtask, name, value) {
    subtask[name] = value
    this.setState({ dataDate: new Date() })
  }

  _onBlur (subtask, name, ev) {
    this._handleInputChanged(subtask, name, true, ev)
  }

  _onKeyPressInput (subtask, name, ev) {
    if (ev.keyCode === 13 || ev.keyCode === 9 || ev.keyCode === 27) {
      if (this._handleInputChanged(subtask, name, false, ev)) {
        ev.preventDefault()
        ev.stopPropagation()
      }
    }
  }

  _handleInputChanged (subtask, name, bBlur, ev) {
    const bEsc = ev.keyCode === 27

    if (!subtask.title) {
      return true
    }

    subtask.editable = false
    if (subtask.title) {
      if (this.props.onUpdate) {
        this.props.onUpdate()
      }
    }

    if (!bBlur && !bEsc) {
      this.props.onUpdateEditable(subtask)
    } else {
      this.setState({ dataDate: new Date() })
    }

    return true
  }
}

export default TaskSubtask
